import React, { useState, useMemo, useEffect } from "react";
import { useHistory } from "react-router-dom";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import MultiSelectCheckbox from "../Helper/MultiSelectCheckbox";
import { useSelector } from "react-redux";
import { Select } from "../Helper/Select";
import SettingsIcon from '@mui/icons-material/Settings';
import ModalOptions from "../Helper/modalOptions";
import { CargaArchivosInventarioModal } from "../ConteosAuditoria/CargaArchivosInventarioModal";
import ReasignarAuditorModal from "./ReasignarAuditorModal";
import { LoaderScreen } from "../../components/LoaderScreen";
import ExtenderFechaModal from "./ExtenderFechaModal";
import EncargadosSucursalModal from "./EncargadosSucursalModal";
import AsignacionPasillosModal from "./AsignacionPasillosModal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { apiMesAJsMonth, DAYS_ES, MONTHS_ES } from "../Helper/Mes";
import { CalendarIcon, ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, ListIcon, ZapIcon } from "../Helper/Icons";
import { EVENT_COLORS } from "../Helper/EventColors";
import { ESTATUS_CONFIG } from "../Helper/EstatusConfigInventario";
import ListadoInventarios from "../Helper/ListadoInventarios";
import ProgramarInventarioModal from "./ProgramarInventarioModal";
import PlantillaScreen3 from "../../helpers/PlantillaScreen3";
import ExtenderFechaJustificacionModal from "../Justificaciones/ExtenderFechaJustificacionModal";
import ModalOptionsWithSub from "../Helper/ModalOptionsWithSub";


// ── Constantes ────────────────────────────────────────────────────────────────


// ── Helpers ───────────────────────────────────────────────────────────────────
function getDaysInMonth(year, month) { return new Date(year, month + 1, 0).getDate(); }
function getFirstDayOfMonth(year, month) { return new Date(year, month, 1).getDay(); }



/**
 * Asigna un color estable a cada sucursal usando su idsucursal.
 */
const colorPorSucursal = (idsucursal) =>
    EVENT_COLORS[idsucursal % EVENT_COLORS.length];

// ── Componente principal ──────────────────────────────────────────────────────
export const ProgramarInventarioMainScreen = () => {
    const today = new Date();
    const history = useHistory();

    const { roles } = useSelector((state) => state.sesion);
    const { idempleado } = useSelector((state) => state.usuario);

    const rolesPermitidos = ["REWR", "AAUD"];

    const rolesPermitidosAuditor = ["REWR", "AAUD", "AUDI"];


    const [administrador, setAdministrador] = useState(false);
    const [esAuditor, setEsAuditor] = useState(false);


    //Estado para modales
    const [openOptionsFolio, setOpenOptionsFolio] = useState(null);
    const [openModalCarga, setOpenModalCarga] = useState(false);
    const [auditoriaSelected, setAuditoriaSelected] = useState(null);
    const [archivoSelected, setArchivoSelected] = useState(null);
    const [sucursalSelected, setSucursalSelected] = useState(null);
    const [openModalReasignar, setOpenModalReasignar] = useState(false);
    const [folioReasignar, setFolioReasignar] = useState("");
    const [openModalFecha, setOpenModalFecha] = useState(false);
    const [folioFecha, setFolioFecha] = useState(null);
    const [fecha_finFecha, setFecha_FinFecha] = useState(null);
    const [openModalEncargados, setOpenModalEncargados] = useState(false);
    const [openModalPasillos, setOpenModalPasillos] = useState(false);
    const [folioPasillos, setFolioPasillos] = useState(null);
    const [openModalProgramar, setOpenModalProgramar] = useState(false);
    const [openModalFechaJustificacion, setOpenModalFechaJustificacion] = useState(false);
    const [folioFechaJustificacion, setFolioFechaJustificacion] = useState(null);
    const [fecha_Justificacion, setFecha_Justificacion] = useState(null);
    const [diferencias, setDiferencias] = useState(null);
    const [justificadas, setJustificadas] = useState(null);
    const [openSubMenu, setOpenSubMenu] = useState(null);



    // Estado del formulario -- Listado son para mostrar los select // sin listado son state originales desde la base de datos
    const [listadoInventarios, setListadoInventarios] = useState([]);
    const [listadoResponsables, setListadoResponsables] = useState([]);
    const [listadoSucursales, setListadoSucursales] = useState([]);
    const [listadoTipoInventario, setListadoTipoInventario] = useState([]);
    const [tipoInventario, setTipoInventario] = useState([]);
    const [listadoCategorias, setListadoCategorias] = useState([]);
    const [listadoAuditores, setListadoAuditores] = useState([]);
    const [listadoEmpleados, setListadoEmpleados] = useState([]);
    const [responsable, setResponsable] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [empleados, setEmpleados] = useState([]);




    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [sucursal, setSucursal] = useState("");
    const [tipoInv, setTipoInv] = useState("");
    const [categoria, setCategoria] = useState("");
    const [encargado, setEncargado] = useState("");
    const [auditor, setAuditor] = useState("");
    const [auditoresAd, setAuditoresAd] = useState("");
    const [fechaInicio, setFechaInicio] = useState(today.toISOString().slice(0, 10));
    const [fechaFin, setFechaFin] = useState(today.toISOString().slice(0, 10));

    // Estado del calendario
    const [viewMode, setViewMode] = useState("list");
    const [calYear, setCalYear] = useState(today.getFullYear());
    const [calMonth, setCalMonth] = useState(today.getMonth()); // 0-11

    const ListadoOpcionesNoIniciado = (ev) => [
        //Cargar de documentos si eres administrador o auditor principal || se revisa que no esten cargados ya
        ...(administrador || Number(ev.id_auditor_ppal) === Number(idempleado) ? [
            ...(!ev.cargado_inventario ? [
                { label: "Cargar inventario", onClick: () => handleOpenModalCarga("I", ev.idsucursal, ev.folio) },
            ] : []),
            ...(!ev.cargado_transito ? [
                { label: "Cargar transito", onClick: () => handleOpenModalCarga("T", ev.idsucursal, ev.folio) },
            ] : []),
            ...(!ev.cargado_surtida ? [
                { label: "Cargar pendiente de surtir", onClick: () => handleOpenModalCarga("S", ev.idsucursal, ev.folio) },
            ] : []),
            { label: "Agregar auditor adicional", onClick: () => onReasignar(ev) },
        ] : []),

        // Asignacion de pasillos
        ...(ev.cargado_inventario && (ev.estatus === "S" | ev.estatus === "I") && (administrador || Number(ev.id_auditor_ppal) === Number(idempleado)) ? [
            { label: "Asignar pasillos", onClick: () => onAsignarPasillos(ev) },
        ] : []),

        // Iniciar conteo solo si los 3 archivos están cargados
        ...(ev.cargado_inventario && ev.estatus === "I" ? [
            { label: "Iniciar conteo", onClick: () => onConteo(ev) },
        ] : []),

        ...(administrador || roles.some(rol => rol.idrol === 'AUDI')) ? [
            { label: "Extender fecha terminacion", onClick: () => onExtenderFecha(ev) },

        ] : [],

        ...(administrador ? [
            // { label: "Extender fecha terminacion", onClick: () => onExtenderFecha(ev) },
            { label: "Eliminar registro", onClick: () => onEliminar(ev.folio) },
        ] : [])

    ];


    const ListadoOpcionesIniciado = (ev) => [

        ...(administrador || Number(ev.id_auditor_ppal) === Number(idempleado) ? [
            ...(!ev.cargado_transito ? [
                { label: "Cargar transito", onClick: () => handleOpenModalCarga("T", ev.idsucursal, ev.folio) },
            ] : []),
            ...(!ev.cargado_surtida ? [
                { label: "Cargar pendiente de surtir", onClick: () => handleOpenModalCarga("S", ev.idsucursal, ev.folio) },
            ] : []),
        ] : []),

        ...(ev.estatus === "P" ? [
            { label: "Continuar conteo", onClick: () => onConteo(ev) },
        ] : []),

        { label: "Ver resultados", onClick: () => onVerResultado(ev) },

        ...(administrador || Number(ev.id_auditor_ppal) === Number(idempleado) ? [
            ev.estatus === "R" ? { label: "Segundo conteo", onClick: () => onRevision(ev) } : { label: "Segundo conteo", onClick: () => onSegundoConteo(ev) }
        ] : []),

        ...((administrador || Number(ev.id_auditor_ppal) === Number(idempleado)) && ev.estatus === "R" ? [
            { label: "Terminar conteo", onClick: () => onFinalizar(ev) },
        ] : []),

        ...(administrador || Number(ev.id_auditor_ppal) === Number(idempleado) ? [
            { label: "Agregar auditor adicional", onClick: () => onReasignar(ev) },
        ] : []),

        // Asignacion de pasillos
        ...(ev.cargado_inventario && (administrador || Number(ev.id_auditor_ppal) === Number(idempleado)) ? [
            { label: "Asignar pasillos", onClick: () => onAsignarPasillos(ev) },
        ] : []),

        ...(administrador || roles.some(rol => rolesPermitidos.includes('AUDI'))) ? [
            { label: "Extender fecha terminacion", onClick: () => onExtenderFecha(ev) },
        ] : [],

        ...(administrador ? [
            { label: "Eliminar registro", onClick: () => onEliminar(ev.folio) },
        ] : [])
    ]

    const ListadoOpcionesTerminado = (ev) => [
        // Reportes — solo administrador o auditor principal
        ...(administrador || Number(ev.id_auditor_ppal) === Number(idempleado) ? [
            {
                label: "Reporte simplificado",
                subOptions: [
                    { label: "Excel", onClick: () => onGenerarReporte(ev, "excel") },
                    { label: "PDF", onClick: () => onGenerarReporte(ev, "pdf") },
                ]
            },
            {
                label: "Reporte primer conteo",
                subOptions: [
                    { label: "Excel", onClick: () => onGenerarReportePrimerConteoExcel(ev, "excel") },
                    { label: "PDF", onClick: () => onGenerarReportePrimerConteo(ev, "pdf") },
                ]
            },
            {
                label: "Reporte segundo conteo",
                subOptions: [
                    { label: "Excel", onClick: () => onGenerarReporteSegundoConteoExcel(ev, "excel") },
                    { label: "PDF", onClick: () => onGenerarReporteSegundoConteo(ev, "pdf") },
                ]
            },
            {
                label: "Ver resumen",
                subOptions: [
                    { label: "PDF", onClick: () => onGenerarReporteResumen(ev, "pdf") },
                ]
            },
        ] : []),

        // Ver resultado — disponible para todos
        { label: "Ver resultado", onClick: () => onVerResultado(ev) },
    ];

    // Navegación
    const prevMonth = () => { if (calMonth === 0) { setCalMonth(11); setCalYear(y => y - 1); } else setCalMonth(m => m - 1); };
    const nextMonth = () => { if (calMonth === 11) { setCalMonth(0); setCalYear(y => y + 1); } else setCalMonth(m => m + 1); };

    // ── Eventos del mes visible para la vista Listado ────────────────────────
    const eventosDelMes = listadoInventarios
        .filter(ev => apiMesAJsMonth(ev.mes) === calMonth && ev.anio === calYear)
        .sort((a, b) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion)); //Orden fecha creacion
    // .sort((a, b) => a.dia - b.dia); //Orden fecha por dia del mes

    // Celdas del calendario (0-11 internamente)
    const calCells = useMemo(() => {
        const firstDay = getFirstDayOfMonth(calYear, calMonth);
        const daysInMon = getDaysInMonth(calYear, calMonth);
        const prevDays = getDaysInMonth(calYear, calMonth === 0 ? 11 : calMonth - 1);
        const cells = [];
        for (let i = firstDay - 1; i >= 0; i--)
            cells.push({ day: prevDays - i, current: false, month: calMonth === 0 ? 11 : calMonth - 1, year: calMonth === 0 ? calYear - 1 : calYear });
        for (let d = 1; d <= daysInMon; d++)
            cells.push({ day: d, current: true, month: calMonth, year: calYear });
        const remaining = 42 - cells.length;
        for (let d = 1; d <= remaining; d++)
            cells.push({ day: d, current: false, month: calMonth === 11 ? 0 : calMonth + 1, year: calMonth === 11 ? calYear + 1 : calYear });
        return cells;
    }, [calYear, calMonth]);

    // ── Mapear evento de la API a la celda del calendario ───────────────────
    // API: { dia, mes (1-12), anio, folio, sucursal, idsucursal, estatus }
    // Celda: { day, month (0-11), year }
    const eventsForCell = (cell) =>
        listadoInventarios.filter(ev =>
            ev.dia === cell.day &&
            apiMesAJsMonth(ev.mes) === cell.month &&
            ev.anio === cell.year
        );

    const isToday = (cell) =>
        cell.current &&
        cell.day === today.getDate() &&
        cell.month === today.getMonth() &&
        cell.year === today.getFullYear();

    // Opciones de selects (estáticas, reemplazar con API según necesidad)
    useEffect(() => {
        const opcionesCat = [
            // { value: "todas", label: "Todas las categorías" }, // opción general siempre disponible
            ...(
                tipoInventario
                    .filter(ti => ti.idtipo === tipoInv)   // filtrar por el inventario seleccionado
                    .map(ti => ({ value: ti.categoria, label: ti.categoria })) // value y label iguales
            )
        ];

        setListadoCategorias(opcionesCat)
    }, [tipoInv]);

    useEffect(() => {
        const opcionResponsable = responsable.find(
            lr => lr.idsucursal === sucursal
        )?.idusuario;
        setEncargado(opcionResponsable);
    }, [sucursal, listadoResponsables]);


    // ── Carga de datos ───────────────────────────────────────────────────────
    useEffect(() => {
        onCargarDatos()

        if (roles.some(rol => rolesPermitidos.includes(rol.idrol))) {
            setAdministrador(true)
            setViewMode("list")
        }

        if (roles.some(rol => rolesPermitidosAuditor.includes(rol.idrol))) {


            setEsAuditor(true)
            setViewMode("list")
        }
    }, []);


    const onCargarDatos = () => {
        setLoading(true);
        request
            .get("ProgramarInventario/Listado")
            .then((result) => {
                // La API devuelve { inventario: [...] }
                setListadoInventarios(result.inventario ?? []);

                const responsableOpciones = (result.responsable ?? []).map(s => ({
                    value: s.idusuario ?? s.idusuario,
                    label: s.usuario
                }));
                setListadoResponsables(responsableOpciones);
                setResponsable(result.responsable ?? []);


                const sucursalesOpciones = (result.sucursales ?? []).map(s => ({
                    value: s.idsucursal ?? s.idsucursal,
                    label: s.sucursal
                }));
                setListadoSucursales(sucursalesOpciones);
                setSucursales(result.sucursales ?? []);

                const tipoInventarioOpciones = Array.from(
                    new Map(
                        (result.categorias ?? []).map(t => [t.idtipo, { value: t.idtipo, label: t.tipo }])
                    ).values()
                );
                setListadoTipoInventario(tipoInventarioOpciones);
                setTipoInventario(result.categorias ?? [])

                const auditoresOpciones = (result.auditores ?? []).map(s => ({
                    value: s.idusuario ?? s.idusuario,
                    label: s.usuario
                }));
                setListadoAuditores(auditoresOpciones);

                const empleadoOpciones = (result.empleados ?? []).map(s => ({
                    value: s.idusuario ?? s.idusuario,
                    label: s.usuario
                }));
                setListadoEmpleados(empleadoOpciones);
                setEmpleados(result.empleados ?? []);
            })
            .catch((error) => {
                Swal.fire("PROGRAMAR INVENTARIO", JSON.stringify(error), "error");
            })
            .finally(() => setLoading(false));
    }

    const onGenerar = () => {
        // Validaciones de campos vacíos
        if (!sucursal) {
            Swal.fire("PROGRAMAR INVENTARIO", "Debe seleccionar una sucursal", "warning");
            return;
        }

        if (!tipoInv) {
            Swal.fire("PROGRAMAR INVENTARIO", "Debe seleccionar un tipo de inventario", "warning");
            return;
        }

        if (!fechaInicio) {
            Swal.fire("PROGRAMAR INVENTARIO", "Debe seleccionar la fecha de inicio", "warning");
            return;
        }

        if (!fechaFin) {
            Swal.fire("PROGRAMAR INVENTARIO", "Debe seleccionar la fecha de fin", "warning");
            return;
        }

        if (!encargado) {
            Swal.fire("PROGRAMAR INVENTARIO", "Debe seleccionar un encargado de almacén", "warning");
            return;
        }

        if (!auditor) {
            Swal.fire("PROGRAMAR INVENTARIO", "Debe seleccionar un auditor principal", "warning");
            return;
        }

        if (!categoria || categoria.length === 0) {
            Swal.fire("PROGRAMAR INVENTARIO", "Debe seleccionar al menos una categoría", "warning");
            return;
        }

        setLoading(true);

        const post = {
            id_sucursal: sucursal,
            tipo_inventario: tipoInv,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            fecha_limite_just: "",
            id_encargado_alm: encargado,
            id_auditor_ppal: auditor,
            observaciones: "",
            auditores_adicionales: auditoresAd,
            categorias: categoria
        }

        request
            .post("ProgramarInventario/Guardar", post)
            .then(async (result) => {
                setLoading(false);

                if (result.resultado === 1) {
                    await Swal.fire(
                        "PROGRAMAR INVENTARIO",
                        result.mensaje,
                        "error"
                    );
                }
                else {
                    await Swal.fire(
                        "PROGRAMAR INVENTARIO",
                        "Programación Registrada con exito",
                        "success"
                    );

                    onCargarDatos()
                }
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire("PROGRAMAR INVENTARIO", JSON.stringify(error), "error");
            });
    };


    const handleCloseModalCarga = () => {
        setOpenModalCarga(false);
        setAuditoriaSelected(null);
        setArchivoSelected(null);
        setSucursalSelected(null);
    };

    const handleOpenModalCarga = (tipoArchivo, sucursalfolio, folio) => {
        setArchivoSelected(tipoArchivo);
        setSucursalSelected(sucursalfolio);
        setAuditoriaSelected(folio)
        setOpenModalCarga(true);
        // handleCloseMenu();
    };


    const onConteo = (ev) => {

        setLoading(true);
        request
            .get(`ProgramarInventario/IniciarConteo?folio=${ev.folio}`)
            .then((result) => {
                const faltantes = [];

                if (!ev.cargado_transito) {
                    faltantes.push("las piezas en tránsito");
                }

                if (!ev.cargado_surtida) {
                    faltantes.push("las piezas surtidas");
                }

                if (faltantes.length > 0) {
                    Swal.fire(
                        "INICIAR CONTEO",
                        `Falta por cargar ${faltantes.join(" y ")}`,
                        "warning"
                    );
                }

                history.push('/Auditoria/RealizarConteo', {
                    folio: ev.folio,
                    idsucursal: ev.idsucursal,
                    sucursal: ev.sucursal,
                    verResultado: false
                });
            })
            .catch((error) => {
                Swal.fire("INICIAR CONTEO", JSON.stringify(error), "error");
            })
            .finally(() => setLoading(false));
    };

    const onSegundoConteo = (ev) => {

        Swal.fire({
            title: "¿Pasar a segundo conteo?",
            text: "Esta acción no se puede deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                onRevision(ev)
            }
        });
    };

    const onRevision = (ev) => {

        setLoading(true);
        request
            .get(`ProgramarInventario/RevisionConteo?folio=${ev.folio}`)
            .then((result) => {
                history.push('/Auditoria/RealizarConteo', {
                    folio: ev.folio,
                    idsucursal: ev.idsucursal,
                    sucursal: ev.sucursal,
                    verResultado: false
                });
            })
            .catch((error) => {
                Swal.fire("RESIGNAR AUDITORES", JSON.stringify(error), "error");
            })
            .finally(() => setLoading(false));


    };

    const onVerResultado = (ev) => {
        history.push('/Auditoria/RealizarConteo', {
            folio: ev.folio,
            idsucursal: ev.idsucursal,
            sucursal: ev.sucursal,
            verResultado: true
        });
    };

    const onFinalizar = (ev) => {

        setFolioFechaJustificacion(ev.folio);
        setFecha_Justificacion(ev.fecha_justificacion);
        setOpenModalFechaJustificacion(true);
        setDiferencias(ev.diferencias)
        setJustificadas(ev.justificadas)
    };

    const onReasignar = (ev) => {
        setFolioReasignar(ev.folio);
        setOpenModalReasignar(true);
    }

    const onExtenderFecha = (ev) => {
        setFolioFecha(ev.folio);
        setFecha_FinFecha(ev.fecha_fin);
        setOpenModalFecha(true);
    };


    const onEditEncargados = () => {
        setOpenModalEncargados(true);
    };

    const onAsignarPasillos = (ev) => {
        setFolioPasillos(ev.folio);
        setOpenModalPasillos(true);
    };

    const onEliminar = (folio) => {

        Swal.fire({
            title: "¿Eliminar registro?",
            text: "Esta acción no se puede deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                onEliminarProgramacion(folio)
            }
        });
    };

    const onEliminarProgramacion = (folio) => {
        setLoading(true);
        request
            .post("ProgramarInventario/EliminarProgramacion", {
                folio
            })
            .then((result) => {
                setLoading(false);

                if (result.resultado === 1) {
                    Swal.fire("PROGRAMACION INVENTARIO", result.mensaje, "error");
                } else {
                    Swal.fire({
                        title: "PROGRAMACION INVENTARIO",
                        text: "Registro eliminado con éxito",
                        icon: "success",
                        customClass: {
                            container: "mi-superpoop",
                        },
                    });
                    onCargarDatos()
                }
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire("PROGRAMACION INVENTARIO", JSON.stringify(error), "error");
            });
    }

    const onGenerarReporte = (ev, formato) => {

        if (formato === "excel") {
            // setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ReportesAuditoriaExcel/GenerarExcelSimplificado?folio=${ev.folio}`
                )
                .then(({ documento, filename }) => {
                    const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${filename}.xlsx`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    // setLoader({ ...loader, mostrar: false });
                })
                .catch((error) => {
                    // setLoader({ ...loader, mostrar: false });
                    Swal.fire("AUDITORIA", JSON.stringify(error), "error");
                });
        }
        if (formato === "pdf") {
            setLoader({ ...loader, mostrar: true });

            request
                .get(`ProgramarInventario/ReporteSimplificadoPDF?folio=${ev.folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    const linkSource = `data:application/pdf;base64, ${result.documento}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${result.nombredocumento}.${result.extension}`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Clientes", JSON.stringify(error), "error");
                });
        }

    };

    const onGenerarReportePrimerConteoExcel = (ev, formato) => {

        if (formato === "excel")
            // setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ReportesAuditoriaExcel/GenerarExcelPrimerConteo?folio=${ev.folio}`
                )
                .then(({ documento, filename }) => {
                    const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${filename}.xlsx`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    // setLoader({ ...loader, mostrar: false });
                })
                .catch((error) => {
                    // setLoader({ ...loader, mostrar: false });
                    Swal.fire("AUDITORIA", JSON.stringify(error), "error");
                });

    };

    const onGenerarReporteSegundoConteoExcel = (ev, formato) => {

        if (formato === "excel")
            // setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ReportesAuditoriaExcel/GenerarExcelSegundoConteo?folio=${ev.folio}`
                )
                .then(({ documento, filename }) => {
                    const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${filename}.xlsx`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    // setLoader({ ...loader, mostrar: false });
                })
                .catch((error) => {
                    // setLoader({ ...loader, mostrar: false });
                    Swal.fire("AUDITORIA", JSON.stringify(error), "error");
                });
        if (formato === "pdf") {
            setLoader({ ...loader, mostrar: true });

            request
                .get(`ProgramarInventario/ReporteSimplificadoPDF?folio=${ev.folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    const linkSource = `data:application/pdf;base64, ${result.documento}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${result.nombredocumento}.${result.extension}`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Clientes", JSON.stringify(error), "error");
                });
        }
    };

    const onGenerarReportePrimerConteo = (ev, formato) => {

        if (formato === "pdf") {
            setLoader({ ...loader, mostrar: true });

            request
                .get(`ProgramarInventario/ReportePrimerConteoPDF?folio=${ev.folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    const linkSource = `data:application/pdf;base64, ${result.documento}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${result.nombredocumento}.${result.extension}`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Clientes", JSON.stringify(error), "error");
                });
        }
    };

    const onGenerarReporteSegundoConteo = (ev, formato) => {

        if (formato === "pdf") {
            setLoader({ ...loader, mostrar: true });

            request
                .get(`ProgramarInventario/ReporteSegundoConteoPDF?folio=${ev.folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    const linkSource = `data:application/pdf;base64, ${result.documento}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${result.nombredocumento}.${result.extension}`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Clientes", JSON.stringify(error), "error");
                });
        }
    };

    const onGenerarReporteResumen = (ev, formato) => {

        if (formato === "pdf") {
            setLoader({ ...loader, mostrar: true });

            request
                .get(`ProgramarInventario/ReporteResumenPDF?folio=${ev.folio}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    const linkSource = `data:application/pdf;base64, ${result.documento}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${result.nombredocumento}.${result.extension}`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("Clientes", JSON.stringify(error), "error");
                });
        }
    };


    const onReporteJustificacionesAuditor = (folio) => {

        setLoader({ ...loader, mostrar: true });

        request
            .get(`ProgramarInventario/JustificacionesAuditorPDF?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };


    const onRegresar = (folio) => {

        history.push('/Auditoria/Main');
    };

    return (
        <PlantillaScreen3 titulo="PROGRAMAR INVENTARIO" className="pa-root">
            <LoaderScreen loader={loader} />

            <div className="programacion-auditoria-actions">
                <div
                    className="programacion-auditoria-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>

            {/* ── FILTROS ── */}
            {/* {esAuditor === true && (
                <div className="pa-filters-panel">
                    <div className="pa-filters-grid">

                        <Select
                            label="Sucursal"
                            options={listadoSucursales}
                            value={sucursal}
                            onChange={setSucursal}
                            placeholder="Seleccione una Sucursal"
                        />
                        <Select
                            label="Encargado almacén"
                            options={listadoResponsables}
                            value={encargado}
                            onChange={setEncargado}
                            placeholder="Seleccione un encargado"
                            disabled
                            icon={<SettingsIcon />}
                            iconClick={onEditEncargados}
                        />

                        <Select
                            label="Auditor principal"
                            options={listadoAuditores}
                            value={auditor}
                            onChange={setAuditor}
                            placeholder="Seleccione un Auditor"
                        />

                        <div className="pa-date-group">
                            <div className="pa-date-field">
                                <label className="pa-label--sm">Fecha de inicio</label>
                                <div className="pa-input-wrap">
                                    <CalendarIcon />
                                    <input type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} />
                                </div>
                            </div>
                            <div className="pa-date-field">
                                <label className="pa-label--sm">Fecha de terminación</label>
                                <div className="pa-input-wrap">
                                    <CalendarIcon />
                                    <input type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} />
                                </div>
                            </div>
                        </div>


                        <Select
                            label="Tipo inventario"
                            options={listadoTipoInventario}
                            value={tipoInv}
                            onChange={setTipoInv}
                            placeholder="Seleccione tipo"
                        />

                        <MultiSelectCheckbox
                            label="Categoría"
                            options={listadoCategorias}
                            value={categoria}
                            onChange={setCategoria}
                            placeholder="Categorías"
                        />

                        <MultiSelectCheckbox
                            label="Auditores adicionales"
                            options={listadoEmpleados}
                            value={auditoresAd}
                            onChange={setAuditoresAd}
                            placeholder="Auditores adicionales"
                        />

                        <div className="pa-generate-wrap">
                            <button className="pa-btn pa-btn--primary" onClick={() => onGenerar()}>
                                <ZapIcon />
                                Generar
                            </button>
                        </div>

                    </div>
                </div>
            )} */}

            {/* ── CALENDARIO ── */}
            <div className="pa-calendar-panel">

                {/* Toolbar */}
                <div className="pa-cal-toolbar">
                    <div className="pa-cal-nav">
                        <button className="pa-cal-nav__btn" onClick={() => setCalYear(y => y - 1)} title="Año anterior"><ChevronsLeft /></button>
                        <button className="pa-cal-nav__btn" onClick={prevMonth} title="Mes anterior"><ChevronLeft /></button>
                        <div className="pa-cal-nav__label">
                            <span className="pa-cal-nav__month">{MONTHS_ES[calMonth]}</span>
                            <span className="pa-cal-nav__year">{calYear}</span>
                        </div>
                        <button className="pa-cal-nav__btn" onClick={nextMonth} title="Mes siguiente"><ChevronRight /></button>
                        <button className="pa-cal-nav__btn" onClick={() => setCalYear(y => y + 1)} title="Año siguiente"><ChevronsRight /></button>
                    </div>

                    <div className="pa-view-toggle">
                        <button className={`pa-view-toggle__btn ${viewMode === "list" ? "active" : ""}`} onClick={() => setViewMode("list")}><ListIcon />Listado</button>
                        {esAuditor === true && (
                            <button className={`pa-view-toggle__btn ${viewMode === "calendar" ? "active" : ""}`} onClick={() => setViewMode("calendar")}><CalendarIcon />Calendario</button>

                        )}
                    </div>
                    {esAuditor === true && (
                        <button
                            className="pa-btn pa-btn--primary"
                            onClick={() => setOpenModalProgramar(true)}
                        >
                            <ZapIcon /> Nuevo inventario
                        </button>
                    )}
                </div>

                {/* Estado de carga */}
                {loading && (
                    <div className="pa-loading">
                        <div className="pa-loading__spinner" />
                        <span>Cargando inventarios...</span>
                    </div>
                )}

                {/* Vista Calendario */}
                {!loading && viewMode === "calendar" && (
                    <div className="pa-cal-container scroll">
                        <div className="pa-cal-grid">
                            {DAYS_ES.map(d => (
                                <div key={d} className="pa-cal-grid__header">{d}</div>
                            ))}
                            {calCells.map((cell, i) => {
                                const events = eventsForCell(cell);
                                return (
                                    <div key={i} className={`pa-cal-cell ${!cell.current ? "other-month" : ""} ${isToday(cell) ? "today" : ""}`}>
                                        <span className="pa-cal-cell__num">{cell.day}</span>
                                        <div className="pa-cal-cell__events">
                                            {events.map((ev, idx) => {
                                                const c = colorPorSucursal(ev.idsucursal);
                                                const est = ESTATUS_CONFIG[ev.estatus] ?? ESTATUS_CONFIG["N"];
                                                const avatarInitials = ev.auditor_ppal
                                                    ?.split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase();

                                                return (
                                                    <>
                                                        <div
                                                            key={`${ev.folio}-${idx}`}
                                                            className="pa-event"
                                                            style={{ background: c.bg, borderColor: c.border }}
                                                            title={`${ev.sucursal} | ${ev.folio}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                // Solo togglear si el click NO viene del popover
                                                                setOpenOptionsFolio(prev =>
                                                                    prev === ev.folio ? null : ev.folio
                                                                );
                                                            }}
                                                        >
                                                            {/* Línea 1: título + avatar auditor */}
                                                            <div className="pa-event__top">
                                                                <span className="pa-event__title">
                                                                    {ev.sucursal} | {ev.folio}
                                                                </span>
                                                                <span
                                                                    className="pa-event__avatar"
                                                                    style={{ background: c.border }}
                                                                    title={ev.auditor_ppal}
                                                                >
                                                                    {avatarInitials}
                                                                </span>
                                                            </div>

                                                            {/* Línea 2: dot de estatus + label */}
                                                            <div className="pa-event__footer">
                                                                <span
                                                                    className="pa-event__estatus-dot"
                                                                    style={{ background: est.dot }}
                                                                />
                                                                <span className="pa-event__estatus-label">
                                                                    {est.label}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        {openOptionsFolio === ev.folio && (
                                                            ev.estatus === "F" ? (
                                                                <div onClick={(e) => e.stopPropagation()}>
                                                                    <ModalOptionsWithSub
                                                                        onClose={() => setOpenOptionsFolio(null)}
                                                                        options={ListadoOpcionesTerminado(ev)}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div onClick={(e) => e.stopPropagation()}>  {/* ← evita que el click suba al pa-event */}
                                                                    <ModalOptions
                                                                        onClose={() => setOpenOptionsFolio(null)}
                                                                        options={ev.estatus === "P" || ev.estatus === "R" ? ListadoOpcionesIniciado(ev) : ev.estatus === "F" ? ListadoOpcionesTerminado(ev) : ListadoOpcionesNoIniciado(ev)}
                                                                    />
                                                                </div>
                                                            )
                                                        )}

                                                    </>
                                                );

                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}

                {/* Vista Listado */}
                {!loading && viewMode === "list" && (
                    <ListadoInventarios
                        data={eventosDelMes}
                        getOpciones={(ev) =>
                            ev.estatus === "P" || ev.estatus === "R"
                                ? ListadoOpcionesIniciado(ev)
                                : ev.estatus === "F"
                                    ? ListadoOpcionesTerminado(ev)
                                    : ListadoOpcionesNoIniciado(ev)
                        }
                        estatus={(ev) => ev.estatus}
                        onReporteJustificacionesAuditor={onReporteJustificacionesAuditor}
                    />
                )}
            </div >

            <CargaArchivosInventarioModal
                open={openModalCarga}
                onClose={handleCloseModalCarga}
                auditoria={auditoriaSelected}
                tipoArchivo={archivoSelected}
                sucursal={sucursalSelected}
                onActualizar={onCargarDatos}
            />

            <ReasignarAuditorModal
                open={openModalReasignar}
                onClose={() => setOpenModalReasignar(false)}
                folio={folioReasignar}
                listadoAuditores={listadoAuditores}
                listadoEmpleados={listadoEmpleados}
                onActualizar={onCargarDatos}
            />

            <ExtenderFechaModal
                open={openModalFecha}
                onClose={() => setOpenModalFecha(false)}
                folio={folioFecha}
                fecha_fin={fecha_finFecha}
                onActualizar={onCargarDatos}
            />

            <EncargadosSucursalModal
                open={openModalEncargados}
                onClose={() => setOpenModalEncargados(false)}
                sucursales={sucursales}
                responsable={responsable}
                empleados={empleados}
                onActualizar={onCargarDatos}
            />

            <AsignacionPasillosModal
                open={openModalPasillos}
                onClose={() => setOpenModalPasillos(false)}
                folio={folioPasillos}
                onActualizar={onCargarDatos}
            />

            <ProgramarInventarioModal
                open={openModalProgramar}
                onClose={() => setOpenModalProgramar(false)}
                onActualizar={onCargarDatos}
                listadoSucursales={listadoSucursales}
                listadoResponsables={listadoResponsables}
                listadoAuditores={listadoAuditores}
                listadoTipoInventario={listadoTipoInventario}
                listadoEmpleados={listadoEmpleados}
                responsable={responsable}
                tipoInventario={tipoInventario}
                onEditEncargados={onEditEncargados}
                SettingsIconComp={SettingsIcon}
            />

            <ExtenderFechaJustificacionModal
                open={openModalFechaJustificacion}
                onClose={() => setOpenModalFechaJustificacion(false)}
                folio={folioFechaJustificacion}
                fecha_fin={fecha_Justificacion}
                onActualizar={onCargarDatos}
                diferencias={diferencias}
                justificadas={justificadas}
            />
        </PlantillaScreen3 >
    );
};

export default ProgramarInventarioMainScreen;
